require("es6-promise").polyfill();
require("./NodeList.prototype.forEach");
require("./Promise.prototype.finally");
